import { defineMessages } from 'react-intl';

export default defineMessages({
    goBack: {
        id: '_.flexi_approved_view.go_back',
        defaultMessage: 'Go back'
    }
});
